import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import ChatModal from '../components/SOS/ChatModal';
import '../style/Dashboard.css';
import 'leaflet/dist/leaflet.css';

const Dashboard = () => {
    const [sosRequests, setSosRequests] = useState([]);
    const [selectedSOS, setSelectedSOS] = useState(null);
    const [isChatOpen, setIsChatOpen] = useState(false);

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (!token) {
            console.error('Токен не найден в локальном хранилище');
            return;
        }

        axios
            .get('https://api.alertapp.kz/api/v1/sos/get-sos-requests', {
                headers: { Authorization: `Bearer ${token}` },
            })
            .then((response) => {
                const sortedRequests = response.data.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
                setSosRequests(sortedRequests);
            })
            .catch((error) => {
                console.error('Ошибка при получении SOS запросов:', error);
            });
    }, []);

    const handleViewDetails = (sos) => {
        setSelectedSOS(sos);

        if (sos.status === 'open') {
            const token = localStorage.getItem('token');
            axios.put(`https://api.alertapp.kz/api/v1/sos/update-status/${sos._id}`, {
                status: 'in_progress'
            }, {
                headers: { Authorization: `Bearer ${token}` },
            })
                .then(() => {
                    setSosRequests(prevRequests => prevRequests.map(req => req._id === sos._id ? { ...req, status: 'in_progress' } : req));
                })
                .catch((error) => {
                    console.error('Ошибка при обновлении статуса SOS запроса:', error);
                });
        }
    };

    const handleOpenChat = () => {
        setIsChatOpen(true);
    };

    const handleCloseModal = () => {
        setSelectedSOS(null);
    };

    const handleCloseChat = () => {
        setIsChatOpen(false);
    };

    const formatTimestamp = (timestamp) => {
        const date = new Date(timestamp);
        return date.toLocaleString();
    };

    return (
        <div className="dashboard-container">
            <table className="sos-table">
                <thead>
                <tr>
                    <th>ФИО пользователя</th>
                    <th>Номер телефона</th>
                    <th>Тип происшествия</th>
                    <th>Адрес происшествия</th>
                    <th>Время</th>
                    <th>Детали</th>
                </tr>
                </thead>
                <tbody>
                {sosRequests.length > 0 ? (
                    sosRequests.map((sos, index) => (
                        <tr
                            key={index}
                            style={{ backgroundColor: sos.status === 'open' ? '#333' : 'white', color: sos.status === 'open' ? 'white' : 'black' }}
                        >
                            <td>{sos.user?.fullName || 'Неизвестно'}</td>
                            <td>{sos.user?.phone || 'Неизвестно'}</td>
                            <td>{sos.description}</td>
                            <td>{sos.address}</td>
                            <td>{formatTimestamp(sos.timestamp)}</td>
                            <td>
                                <button
                                    className="view-button"
                                    onClick={() => handleViewDetails(sos)}
                                >
                                    Посмотреть
                                </button>
                            </td>
                        </tr>
                    ))
                ) : (
                    <tr>
                        <td colSpan="6" className="no-data">
                            Нет доступных SOS запросов
                        </td>
                    </tr>
                )}
                </tbody>
            </table>

            {selectedSOS && (
                <div className="modal">
                    <div className="modal-content">
                        <h2>Детали SOS запроса</h2>
                        <p>
                            <strong>ФИО пользователя:</strong>{' '}
                            {selectedSOS.user?.fullName || 'Неизвестно'}
                        </p>
                        <p>
                            <strong>Номер телефона:</strong>{' '}
                            {selectedSOS.user?.phone || 'Неизвестно'}
                        </p>
                        <p>
                            <strong>Тип происшествия:</strong> {selectedSOS.description}
                        </p>
                        <p>
                            <strong>Адрес:</strong> {selectedSOS.address}
                        </p>
                        <p>
                            <strong>Время:</strong> {formatTimestamp(selectedSOS.timestamp)}
                        </p>
                        <div className="map-container">
                            <MapContainer
                                center={[
                                    selectedSOS.location.latitude,
                                    selectedSOS.location.longitude,
                                ]}
                                zoom={13}
                                style={{ height: '300px', width: '100%' }}
                            >
                                <TileLayer
                                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                    attribution='&copy; <a href="https://osm.org/copyright">OpenStreetMap</a> contributors'
                                />
                                <Marker
                                    position={[
                                        selectedSOS.location.latitude,
                                        selectedSOS.location.longitude,
                                    ]}
                                >
                                    <Popup>Местоположение происшествия</Popup>
                                </Marker>
                            </MapContainer>
                        </div>
                        <button className="close-button" onClick={handleCloseModal}>
                            Закрыть
                        </button>
                        <button className="chat-button" onClick={handleOpenChat}>
                            Связаться
                        </button>
                    </div>
                </div>
            )}

            {isChatOpen && selectedSOS && (
                <ChatModal
                    sos={{
                        ...selectedSOS,
                        token: localStorage.getItem('token'),
                        chatId: selectedSOS.chatId._id,
                    }}
                    onClose={handleCloseChat}
                />
            )}
        </div>
    );
};

export default Dashboard;
